import React, { useEffect, useState } from "react";
import { Form, Row, Col, Card } from "react-bootstrap";
import { FaMotorcycle } from "react-icons/fa";
import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import "./ShippingWellness.css";
import "./../../common_components/common_css/Common_com.css";
import WhiteButton from "../../common_components/common_button/WhiteButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan, faPenToSquare } from "@fortawesome/free-solid-svg-icons";

import { faPlus, faMinus } from "@fortawesome/free-solid-svg-icons";
import {
  addAddress,
  getAllAddress,
  GetSinglelAddress,
  updateAddress,
  deleteAddress,
  postOrder,
} from "../../../features/admin/product/productdetails/Slice";
import { useDispatch, useSelector } from "react-redux";
import { AllCity } from "../../../features/admin/common/Slice";
import Cookies from "js-cookie";
import { useLocation } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";
import { GETProfile, Update_Profile } from "../../../features/admin/auth/Slice";

const ShippingWellness = ({
  productsdetails,
  qty,
  setQty,
  setCheckoutData,
  setTriggerSubmit,
  all_app_setup,
}) => {
  const getUserId = () => {
    const token = Cookies.get("spirulina_website_security");

    if (!token) return null;

    return token.split("|")[0];
  };

  const dispatch = useDispatch();

  const [activeSection, setActiveSection] = useState(1);
  const [selectedAddressId, setSelectedAddressId] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  const location = useLocation();

  const getOrderType = () => {
    const cookieData = Cookies.get("orderData");

    if (cookieData) {
      const parsed = JSON.parse(cookieData);
      if (parsed?.type) return parsed.type;
    }

    return location?.state?.type || "mlm";
  };
  const orderType = getOrderType();
  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
    reset,
    trigger,
    getValues,
    setValue,
  } = useForm();

  useEffect(() => {
    dispatch(getAllAddress());
    dispatch(AllCity());
    dispatch(GETProfile());
  }, [dispatch]);

  const maxQty = all_app_setup?.[0]?.static_shareholder_percent || 0;

  useEffect(() => {
    if (orderType === "shareholder" && maxQty > 0) {
      setQty(maxQty);
    }
  }, [orderType, maxQty, setQty]);

  const userAddress = useSelector(
    (state) => state?.product?.productdetails?.all_user_address,
  );

  const all_cities = useSelector((state) => state?.common?.all_cities);

  const profileDetails = useSelector(
    (state) => state?.auth?.login?.getCustomerData,
  );

  const handleDelete = () => {
    if (!deleteId) return;

    dispatch(deleteAddress(deleteId)).then(() => {
      dispatch(getAllAddress());
      setShowDeleteModal(false);
      setDeleteId(null);
    });
  };

  useEffect(() => {
    setTriggerSubmit(() => handleSubmit(handleCheckoutData));
  }, [handleSubmit, qty]);

  const [editId, setEditId] = useState(null);

  const handleEdit = (id) => {
    setEditId(id);

    dispatch(GetSinglelAddress(id)).then((res) => {
      const address = res?.payload?.data?.[0];

      if (address) {
        reset({
          address2: address.address2,
        });

        setActiveSection(2);
      }
    });
  };

  // submit handler
  // const handleAddressSave = async () => {
  //   const isValid = await trigger("address2"); // validate only address field

  //   if (!isValid) return;

  //   const address2 = getValues("address2");

  //   const payload = {
  //     address2,
  //   };

  //   if (editId) {
  //     dispatch(updateAddress({ id: editId, data: payload })).then(() => {
  //       dispatch(getAllAddress());
  //       setEditId(null);
  //       setActiveSection(1);
  //       reset({ address2: "" });
  //     });
  //   } else {
  //     dispatch(addAddress(payload)).then((res) => {
  //       if (res?.payload) {
  //         dispatch(getAllAddress());
  //         setActiveSection(1);
  //         reset({ address2: "" });
  //       }
  //     });
  //   }
  // };

  const handleAddressSave = async () => {
    const isValid = await trigger("address2");

    if (!isValid) return;

    const address2 = getValues("address2");

    const payload = {
      address2,
    };

    if (editId) {
      dispatch(updateAddress({ id: editId, data: payload })).then((res) => {
        if (res?.payload?.success) {
          dispatch(getAllAddress());

          setSuccessMessage("Address updated successfully");
          setShowSuccessModal(true);

          setEditId(null);
          setActiveSection(1);

          reset({ address2: "" });

          setTimeout(() => {
            setShowSuccessModal(false);
          }, 3000);
        }
      });
    } else {
      dispatch(addAddress(payload)).then((res) => {
        if (res?.payload?.success) {
          dispatch(getAllAddress());

          setSuccessMessage("Address saved successfully");
          setShowSuccessModal(true);

          setActiveSection(1);

          reset({ address2: "" });

          setTimeout(() => {
            setShowSuccessModal(false);
          }, 3000);
        }
      });
    }
  };

  const handleCheckoutData = (data) => {
    if (!data.address_id) {
      alert("Please select address");
      return;
    }

    const user_id = getUserId();

    const payload = {
      user_id,
      full_name: data.name,
      email: data.email,
      address_id: Number(data.address_id),
      city_id: data.city_id?.value,
      city_name: data.city_id?.label,
      pincode: data.pincode,
      quantity: Number(qty), // ensure latest qty
      payment_method_id: 2,
      type: orderType,
    };

    setCheckoutData(payload);

    Cookies.set("shippingData", JSON.stringify(payload));

    return payload;
  };

  // const [qty, setQty] = useState(0);

  // const maxQty = productsdetails?.productdetails?.quantity || 0;

  const decreaseQty = () => {
    if (orderType === "shareholder") return; // 🚫 block
    if (qty > 1) setQty(qty - 1);
  };

  const increaseQty = () => {
    if (orderType === "shareholder") return; // 🚫 block
    if (qty < maxQty) setQty(qty + 1);
  };
  // useEffect(() => {
  //   const orderData = Cookies.get("orderData");

  //   if (orderData) {
  //     const parsed = JSON.parse(orderData);

  //     reset({
  //       name: parsed.full_name,
  //       email: parsed.email,
  //       pincode: parsed.pincode,
  //       city_id: parsed.city_id
  //         ? { value: parsed.city_id, label: parsed.city_name || "" }
  //         : null,
  //     });

  //     setSelectedAddressId(parsed.address_id);
  //     setValue("address_id", parsed.address_id);
  //     setQty(parsed.quantity || 1);
  //   }
  // }, [reset, setQty]);
  useEffect(() => {
    const orderData = Cookies.get("orderData");

    if (orderData) {
      const parsed = JSON.parse(orderData);

      reset({
        name: parsed.full_name,
        email: parsed.email,
        pincode: parsed.pincode,
        city_id: parsed.city_id
          ? { value: parsed.city_id, label: parsed.city_name || "" }
          : null,
      });

      // setSelectedAddressId(parsed.address_id);
      // setValue("address_id", parsed.address_id);
      // setQty(parsed.quantity || 1);
      if (orderType === "shareholder") {
        setQty(maxQty || 1);
      } else {
        setQty(parsed.quantity || 1);
      }
    }
  }, [reset, setQty, orderType, maxQty]);

  useEffect(() => {
    const orderData = Cookies.get("orderData");

    // COOKIE EXIST
    if (orderData) {
      const parsed = JSON.parse(orderData);

      // DEFAULT ADDRESS
      if (
        Number(parsed.address_id) === Number(profileDetails?.user_address?.id)
      ) {
        setSelectedAddressId("default");
        setValue("address_id", "default");
        return;
      }

      // SAVED ADDRESS
      const matchedAddress = userAddress?.find(
        (addr) => Number(addr.id) === Number(parsed.address_id),
      );

      if (matchedAddress) {
        setSelectedAddressId(matchedAddress.id);
        setValue("address_id", matchedAddress.id);
        return;
      }
    }

    // AUTO SELECT DEFAULT
    if (profileDetails?.user_address?.id) {
      setSelectedAddressId("default");
      setValue("address_id", "default");
      return;
    }

    setSelectedAddressId(null);
    setValue("address_id", null);
  }, [userAddress, profileDetails, setValue]);

  useEffect(() => {
    Cookies.remove("shippingData");
  }, []);

  // useEffect(() => {
  //   if (userAddress?.length && !selectedAddressId) {
  //     const firstId = userAddress[0]?.id;

  //     setSelectedAddressId(firstId);
  //     setValue("address_id", firstId);
  //   }
  // }, [userAddress, selectedAddressId, setValue]);

  return (
    <div className="shipping-section">
      <h4 className="shipping-title">Shipping & Wellness Delivery</h4>

      <p className="shipping-subtitle">
        Enter your details to receive your organic food supplements
      </p>

      <Form onSubmit={handleSubmit(handleCheckoutData)}>
        {" "}
        {/* Full Name */}
        <Form.Group className="mb-3 mt-4">
          <Form.Label className="ml-5">Full Name</Form.Label>
          <Form.Control
            type="text"
            placeholder="eg. sarah jamdar"
            className="custom-input"
            onInput={(e) => {
              e.target.value = e.target.value.replace(/[^A-Za-z\s]/g, "");
            }}
            {...register("name", {
              required: "Name is required",
              minLength: {
                value: 3,
                message: "Name must be at least 3 characters",
              },
              pattern: {
                value: /^[A-Za-z\s]+$/,
                message: "Only alphabets are allowed",
              },
            })}
          />
          {errors.name && (
            <small className="text-danger">{errors.name.message}</small>
          )}
        </Form.Group>
        <Form.Group className="mb-3 mt-4">
          {" "}
          <Form.Label>Email Address</Form.Label>
          <Form.Control
            type="email"
            placeholder="eg. sarahjamdar@example.com"
            className="custom-input"
            onInput={(e) => {
              e.target.value = e.target.value.replace(/\s/g, "");
            }}
            {...register("email", {
              required: "Email is required",
              pattern: {
                value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,}$/,
                message: "Enter a valid email address",
              },
            })}
          />
          {errors.email && (
            <small className="text-danger">{errors.email.message}</small>
          )}
        </Form.Group>
        <hr className="my-4" />
        {/* Address */}
        {activeSection === 1 && (
          <section id="1">
            <Form.Label className="mt-3">Address</Form.Label>

            <Row className="mb-3">
              <Col md={6}>
                {/* <div className="saved-address-scroll">
                  {userAddress?.map((addr, index) => ( */}

                <div className="saved-address-scroll">
                  {/* Default Address from Profile */}
                  {profileDetails?.user_address?.address1?.trim() && (
                    <Card className="p-3 address-card card1 mb-2 default-address-card">
                      <div className="address-delete-edit">
                        <Form.Check
                          id="default-address"
                          type="radio"
                          label="Default Address"
                          value="default"
                          checked={selectedAddressId === "default"}
                          {...register("address_id", { required: true })}
                          onChange={() => {
                            setSelectedAddressId("default");
                            setValue("address_id", "default");
                          }}
                        />

                        {/* <div className="default-badge">Default</div> */}
                      </div>

                      <small className="text-muted">
                        {profileDetails?.user_address?.address1}
                      </small>
                    </Card>
                  )}

                  {/* Saved Addresses */}
                  {userAddress?.map((addr, index) => (
                    <Card className="p-3 address-card card1 mb-2" key={index}>
                      <div className="address-delete-edit">
                        {/* <Form.Check
                          type="radio"
                          label={`Saved address ${index + 1}`}
                          name="address"
                          value={addr.address2}
                        /> */}
                        <Form.Check
                          id={`address-${addr.id}`}
                          type="radio"
                          label={`Saved address ${index + 1}`}
                          value={addr.id}
                          // checked={selectedAddressId === addr.id}
                          checked={
                            Number(selectedAddressId) === Number(addr.id)
                          }
                          {...register("address_id", { required: true })}
                          onChange={() => {
                            setSelectedAddressId(addr.id);
                            setValue("address_id", addr.id);
                          }}
                        />
                        <div className="icons">
                          <FontAwesomeIcon
                            icon={faPenToSquare}
                            // onClick={() => setActiveSection(2)}
                            onClick={() => handleEdit(addr.id)}
                          />
                          <FontAwesomeIcon
                            icon={faTrashCan}
                            // onClick={() => handleDelete(addr.id)}
                            onClick={() => {
                              setDeleteId(addr.id);
                              setShowDeleteModal(true);
                            }}
                          />{" "}
                        </div>
                      </div>
                      <small className="text-muted">{addr.address2}</small>
                    </Card>
                  ))}
                </div>
              </Col>

              <Col
                md={
                  userAddress?.length || profileDetails?.user_address?.address1
                    ? 6
                    : 12
                }
              >
                <Card
                  className="p-3 text-center address-card card2"
                  onClick={() => setActiveSection(2)}
                >
                  <div className="fs-3 plus-circle">+</div>
                  <p>Add New Address</p>
                </Card>
              </Col>
            </Row>
          </section>
        )}
        {activeSection === 2 && (
          <section id="2" className="address-section">
            <div className="address-heading">
              <div className="left-title">Add New Address</div>
              {/* <div className="right-title" onClick={() => setActiveSection(1)}>
                Proceed with Previous Address
              </div> */}
            </div>

            <Row className="mb-3">
              <Form.Group className="form-group-common">
                <Form.Label className="form-label-common">
                  Street Address
                </Form.Label>

                <Form.Control
                  as="textarea"
                  rows={2}
                  className="form-control-common address-textarea"
                  placeholder="eg. Akshya Nagar 1st Block 1st Cross, Ramurthy Nagar, Bangalore -560016"
                  {...register("address2", {
                    required: "Street address is required",
                  })}
                />

                {/* Validation Error */}
                {errors.address2 && (
                  <Form.Text className="text-danger">
                    {errors.address2.message}
                  </Form.Text>
                )}
                <div>
                  <WhiteButton
                    className="purchase-btn"
                    title="Save"
                    bg="#010E1E"
                    color="#F35F37"
                    hoverBg="#010E1E"
                    hoverColor="#F35F37"
                    type="button"
                    onClick={handleAddressSave}
                  />
                </div>
              </Form.Group>
            </Row>
          </section>
        )}
        {/* City & Zip */}
        <Row>
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>City</Form.Label>
              <Controller
                name="city_id"
                control={control}
                rules={{ required: "City is required" }}
                render={({ field }) => (
                  <Select
                    {...field}
                    options={all_cities}
                    value={field.value}
                    onChange={(val) => field.onChange(val)}
                    onInputChange={(val) => {
                      dispatch(AllCity(val));
                    }}
                  />
                )}
              />

              {errors?.city_id && (
                <Form.Text className="text-danger">
                  {errors?.city_id?.message}
                </Form.Text>
              )}
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Zipcode</Form.Label>

              <Form.Control
                type="text"
                placeholder="eg. 411041"
                maxLength={6}
                // ✅ Allow only numbers while typing
                onInput={(e) => {
                  let value = e.target.value;

                  // remove alphabets & symbols
                  value = value.replace(/[^0-9]/g, "");

                  // ensure max 6 digits (for paste case)
                  value = value.slice(0, 6);

                  e.target.value = value;
                }}
                {...register("pincode", {
                  required: "Pincode is required",

                  pattern: {
                    value: /^[0-9]{6}$/,
                    message: "Pincode must be exactly 6 digits",
                  },
                })}
              />

              {errors?.pincode && (
                <Form.Text className="text-danger">
                  {errors?.pincode?.message}
                </Form.Text>
              )}
            </Form.Group>
          </Col>
        </Row>
        {/* Delivery Info */}
        <div className="delivery-info d-flex align-items-center mt-2">
          {/* <FaMotorcycle className="me-2 delivery-icon" /> */}
          <img src="/images/cart/fast-delivery.png" alt="not" />
          <p>
            Delivery is available in your location.
            <span className="highlight">
              {" "}
              Order now & enjoy quick delivery.
            </span>
          </p>
        </div>
        <hr className="my-4" />
        {/* Quantity */}
        <div className="qty-wrapper">
          {/* <Form.Label className="qty-label">QTY</Form.Label>
          <Controller
            name="country"
            control={control}
            defaultValue={{ value: 1, label: "01 QTY" }}
            render={({ field }) => (
              <Select
                {...field}
                className="qty-select"
                classNamePrefix="qty"
                options={[
                  { value: 1, label: "01 QTY" },
                  { value: 2, label: "02 QTY" },
                  { value: 3, label: "03 QTY" },
                  { value: 4, label: "04 QTY" },
                ]}
                onChange={(selected) => field.onChange(selected)}
              />
            )}
          /> */}
          <Form.Label className="qty-label">QTY</Form.Label>

          <div className="qty-container">
            {/* <button type="button" className="qty-btn" onClick={decreaseQty}> */}
            <button
              type="button"
              className="qty-btn"
              onClick={decreaseQty}
              disabled={orderType === "shareholder"}
            >
              <FontAwesomeIcon icon={faMinus} />
            </button>

            <span className="qty-number">{qty}</span>

            {/* <button
              type="button"
              className="qty-btn"
              onClick={increaseQty}
              disabled={qty >= maxQty}
            > */}
            <button
              type="button"
              className="qty-btn"
              onClick={increaseQty}
              disabled={orderType === "shareholder" || qty >= maxQty}
            >
              <FontAwesomeIcon icon={faPlus} />
            </button>
          </div>
        </div>{" "}
        {qty >= maxQty && (
          <small className="text-danger ">
            Maximum available quantity is {maxQty}
          </small>
        )}
        {/* Referral Info */}
        <div className="referral-info ">
          <img src="/images/cart/star.png" alt="not" />
          <p>
            <strong>
              Buy just 1 product to <span> activate your account.</span>
            </strong>
            <br />
            After activation, refer others & earn income through our referral
            program.
          </p>
        </div>
      </Form>

      {/* Success address modal */}

      <Modal
        show={showSuccessModal}
        onHide={() => setShowSuccessModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Success</Modal.Title>
        </Modal.Header>

        <Modal.Body className="text-center">{successMessage}</Modal.Body>

        <Modal.Footer>
          <Button variant="success" onClick={() => setShowSuccessModal(false)}>
            OK
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete Address</Modal.Title>
        </Modal.Header>

        <Modal.Body>Are you sure you want to delete this address?</Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setShowDeleteModal(false);
              setDeleteId(null);
            }}
          >
            Cancel
          </Button>

          <Button variant="danger" onClick={handleDelete}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ShippingWellness;
